const DatePickerStates = {
    START: 'START',
    SOFT_START: 'SOFT_START',
    END: 'END',
    DONE: 'DONE',
    CLOSED: 'CLOSED'
};

const DatePickerAlertLevels = {
    ERROR: 'red',
    WARNING: 'yellow',
    INFO: 'blue',
    SUCCESS: 'green'
};

const DatePickerAlertIcons = {
    ALERT: 'ALERT_ALERT__50',
    CHECK: 'ALERT_CHECK__50',
    DANGER: 'ALERT_DANGER__50',
    INFO: 'ALERT_INFO__50',
    TAP: 'ALERT_TAP_TARGET__50'
};

const DatePickerAlertAnimations = {
    SLIDE_IN: 'slide-in-down',
    SLIDE_OUT: 'slide-out-up',
    BOUNCE: 'bounce'
};

const DatePickerAlertSpeeds = {
    SLOW: 1000,
    MEDIUM: 500,
    INSTANT: 0
};

export {
    DatePickerStates,
    DatePickerAlertLevels,
    DatePickerAlertIcons,
    DatePickerAlertAnimations,
    DatePickerAlertSpeeds
};
